import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@homeaway/react-buttons';
import translate from '../../../utils/translations';
import ManageBooking from './ManageBooking/ManageBooking';

import './PolicySection.less';

export class PolicySection extends React.PureComponent {
    static propTypes = {
        backUrl: PropTypes.string,
        conversationId: PropTypes.string,
        isPrimary: PropTypes.bool,
        listingId: PropTypes.string,
        location: PropTypes.string,
        policies: PropTypes.arrayOf(
            PropTypes.shape({
                description: PropTypes.string,
                href: PropTypes.string,
                title: PropTypes.string,
                translations: PropTypes.shape({}),
                type: PropTypes.string,
            })
        ),
        priceDetails: PropTypes.shape({}),
        refetch: PropTypes.func,
        reservationId: PropTypes.string,
        shortDisplayName: PropTypes.string,
        showRefundInfoBtn: PropTypes.bool,
        systemData: PropTypes.shape({}),
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        backUrl: '/traveler/th/inbox',
        refetch: () => {},
        systemData: {},
        translations: {},
    };

    render() {
        const {
            backUrl,
            conversationId,
            isPrimary,
            listingId,
            location,
            policies,
            priceDetails,
            refetch,
            reservationId,
            shortDisplayName,
            showRefundInfoBtn,
            systemData,
            translations,
        } = this.props;
        const filteredPolicies = [];

        // THIS IS THE LAST THING LEFT IN QUOTESUMMARY
        if (policies?.length) {
            const isMobile = systemData?.isMobile;
            policies.forEach((policy, index) => {
                if (policy.href) {
                    filteredPolicies.push(
                        <div key={index}>
                            {isMobile && (
                                <h3 className="text-align-center">
                                    {policy.title}
                                </h3>
                            )}
                            {!isMobile && <h2>{policy.title}</h2>}
                            <div className="row">
                                <div className="hidden-print col-sm-8 col-sm-offset-2 col-xs-12 text-center">
                                    <Button
                                        className={'btn--nowrap'}
                                        href={policy.href}
                                        label={translate(
                                            translations,
                                            'trav-dash/trav-home',
                                            'messages',
                                            'th.inbox.conversation.quoteSummary.attachment'
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                }
            });
        }

        return (
            <div>
                {filteredPolicies.length > 0 && (
                    <div className="policy-section rounded-border">
                        {filteredPolicies}
                    </div>
                )}
                {isPrimary && reservationId && (
                    <ManageBooking
                        backUrl={backUrl}
                        conversationId={conversationId}
                        listingId={listingId}
                        location={location}
                        priceDetails={priceDetails}
                        refetch={refetch}
                        reservationId={reservationId}
                        shortDisplayName={shortDisplayName}
                        showRefundInfoBtn={showRefundInfoBtn}
                        systemData={systemData}
                        translations={translations}
                    />
                )}
            </div>
        );
    }
}
